<template>
  <v-app>
    <Navbar v-if="!isNavbarHidden" :auto-hide="isBibleStudyPage" />

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import {ehDominioCasamento} from '@/components/casamento/rotas';

export default {
  name: 'App',
  components: {
    Navbar
  },
  computed: {
    // Até a navegação inicial resolver o chunk da rota, $route ainda é a rota
    // START ('/', matched vazio) — decidir por ela faz a navbar aparecer e
    // sumir. Nessa janela o caminho real só existe em window.location.
    currentPath() {
      return this.$route.matched.length
        ? this.$route.path
        : window.location.pathname;
    },
    isNavbarHidden() {
      // No domínio do casamento a navbar do escritório nunca aparece — lá as
      // rotas ficam na raiz e não casariam com as regras de caminho abaixo.
      if (ehDominioCasamento) return true;

      // Esconde a Navbar na página de login e em todas as rotas de casamento/cha-de-panela
      return this.currentPath === '/login'
        || this.currentPath.startsWith('/casamento')
        || this.currentPath.startsWith('/cha-de-panela')
        || this.currentPath.startsWith('/financas')
        || this.currentPath.startsWith('/casa');
    },
    isBibleStudyPage() {
      return this.currentPath.startsWith('/estudo-biblico');
    }
  }
};
</script>
